module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Payments/Apple Pay-65d442990f19a05c05fca31144c1f690.svg";